

function ScorecardManageSettingsController($q, sections, ScorecardService) {
    var vm = this;

    vm.sections = [];
    vm.ybusaSections = [];
    vm.programSections = [];
    vm.pages = [[vm.programSections, 'Fiscal Practices', false],
                [vm.ybusaSections,   'Fiscal Scorecard', true]]

    vm.newSection = newSection;
    vm.saveOrder = saveOrder;

    setSections(sections);

    function saveOrder(data) {
        return ScorecardService
            .patchOrder('section', data.sections)
            .then(setSections);
    }

    function newSection(data) {
        return ScorecardService
            .createSection(data)
            .then(addSection);
    }

    function addSection(section) {
        vm.sections.push(section);
        setSections(vm.sections);
    }

    function setSections(sections) {
        vm.sections = sections;
        setSection(vm.ybusaSections, sections, true);
        setSection(vm.programSections, sections, false);
    }

    function setSection(array, data, is_ybusa) {
        array.splice(0, array.length);
        array.push.apply(array, data.filter(function(item) {
            return item.is_ybusa === is_ybusa;
        }));
    }

}

function ScorecardSectionSettingsController(ScorecardService, section, questions) {
    var vm = this;

    vm.dataTypes = [
        ['radio', 'Scored Options'],
        ['short', 'Text Response'],
        ['info',  'Information'],
    ]

    vm.section = section;
    vm.questions = questions;

    vm.saveSection = saveSection;
    vm.deleteSection = deleteSection;
    vm.getOption = getOption;
    vm.saveOrder = saveOrder;
    vm.newQuestion = newQuestion;

    function saveSection(data) {
        return ScorecardService.patchSection(vm.section, data);
    }

    function deleteSection() {
        return ScorecardService.deleteSection(vm.section);
    }

    function newQuestion(data) {
        data.section_id = vm.section.id;
        return ScorecardService
            .createQuestion(data)
            .then(addQuestion);
    }

    function addQuestion(question) {
        vm.questions.push(question);
    }

    function saveOrder(data) {
        return ScorecardService
            .patchOrder('question', data.questions)
            .then(function(questions) {
                angular.copy(questions, vm.questions);
            });
    }


    function getOption(opt) {
        return opt[0];
    }
}

function ScorecardQuestionSettingsController(ScorecardService, question, section, validConditions) {
    var vm = this;

    vm.newCounter = 1;

    vm.section = section;
    vm.question = question;
    vm.questionTypes = getValidQuestionTypes(question.question_type);
    vm.hasOptions = (question.question_type === 'radio' ||
                     question.question_type === 'select')

    vm.getNewOption = getNewOption;
    vm.patchQuestion = patchQuestion;
    vm.patchOptions = patchOptions;
    vm.getOptionValue = getOptionValue;
    vm.deleteQuestion = deleteQuestion;

    vm.conditionalQuestions = getConditionalQuestions(validConditions);
    vm.conditionalValues = getConditionalValues(validConditions);
    console.log(vm.conditionalQuestions);

    function patchQuestion(data) {
        if (!data.question_type) {
            data.question_type = question.question_type;
        }
        return ScorecardService
            .patchConfigItem('question', vm.question, data);
    }

    function deleteQuestion() {
        return ScorecardService
            .deleteConfigItem('question', question);
    }

    function patchOptions(data) {
        return ScorecardService
            .patchOptions(vm.question, data.options)
    }

    function getNewOption() {
        return {
            id: 'new_' + (vm.newCounter++),
            weight: getMaxOptionWeight() + 1,
        };
    }

    function getMaxOptionWeight() {
        return vm.question.options.reduce(function(a, b) {
            return a > b.weight ? a : b.weight;
        }, 0)
    }

    function getValidQuestionTypes(question_type) {
        if (question_type === 'radio' || question_type === 'select') {
            return [['radio',  'Radios'], ['select', 'Select']];
        } else if (question_type === 'long' || question_type === 'short') {
            return [['short',  'Short Text'], ['long',   'Long Text']]
        } else if (question_type === 'info') {
            return [['info', 'Information']];
        } else {
            return [];
        }
    }

    function getConditionalQuestions(questions) {
        value = questions.filter(function(question) {
            return (question.id !== vm.question.id &&
                    !question.conditional_on_id)
        }).map(function(question) {
            return [question.id, question.text];
        });
        value.splice(0, 0, [null, 'No Conditional'])
        return value;
    }

    function getConditionalValues(questions) {
        return questions.reduce(function(cache, question) {
            cache[question.id] = question.options.map(function(opt) {
                return [opt.id, opt.text];
            });
            return cache;
        }, {});
    }


    function getOptionValue(option) { return option[0]; }
}

module.controller('ScorecardManageSettingsController',
                  ScorecardManageSettingsController)
module.controller('ScorecardSectionSettingsController',
                  ScorecardSectionSettingsController)
module.controller('ScorecardQuestionSettingsController',
                  ScorecardQuestionSettingsController)